import client from "../utils/ApiHelper.js";
import ErrorException from "../utils/Exceptions.js";

async function fetchAllWarehouse() {
    try {
        let res = await client.get("/warehouse");

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function fetchOneWarehouse(id) {
    try {
        let res = await client.get("/warehouse/warehouse_id/" + id);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function createWarehouse(name, address, image) {
    const form = new FormData();
    form.append("name", name);
    form.append("address", address);
    form.append("image", image);


    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    try {
        let res = await client.post("/warehouse/create", form, config);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function updateWarehouse(id, name, address, image) {
    const form = new FormData();
    form.append("id", id);
    form.append("name", name);
    form.append("address", address);
    form.append("image", image);

    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    try {
        let res = await client.post("/warehouse/update", form, config);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function deleteWarehouse(id) {
    try {
        let res = await client.delete("/warehouse/warehouse_id/" + id);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

export {
    fetchAllWarehouse,
    fetchOneWarehouse,
    createWarehouse,
    updateWarehouse,
    deleteWarehouse,
};
